export const safeParseJwtPayload = (token: string): Record<string, any> | null => {
    try {
      const parts = token.split('.')
      if (parts.length < 2) return null
      const base64Url = parts[1]
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
      // pad to valid base64 length
      const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=')
      const json = decodeURIComponent(
        Array.prototype.map
          .call(atob(padded), (c: string) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join(''),
      )
      return JSON.parse(json)
    } catch {
      return null
    }
  }
  
  export const logAccessTokenExpire = (accessToken: string) => {
    const payload = safeParseJwtPayload(accessToken)
    const expire = payload?.exp
    if (!expire) return
  
    let expireDate: Date | null = null
    if (typeof expire === 'number') {
      // heuristics: seconds vs milliseconds
      expireDate = new Date(expire < 1e12 ? expire * 1000 : expire)
    } else if (typeof expire === 'string') {
      const asNumber = Number(expire)
      if (!Number.isNaN(asNumber)) {
        expireDate = new Date(asNumber < 1e12 ? asNumber * 1000 : asNumber)
      } else {
        const d = new Date(expire)
        expireDate = Number.isNaN(d.getTime()) ? null : d
      }
    }

    return expire;
  
  }